/**
 * Commissioning Authorities Service
 * Admin management of the commissioning authority taxonomy (name, type,
 * nation, legacy names). Used by tender ingestion, matching and the
 * organisation profile picker — see backend
 * src/services/commissioningAuthorities.service.js.
 */
import { api } from './api'

const BASE = '/admin/commissioning-authorities'

export const commissioningAuthoritiesService = {
    async getAll() {
        const res = await api.get(BASE)
        if (!res.success) throw new Error('Failed to fetch commissioning authorities')
        return res.data || []
    },

    async getOptions() {
        const res = await api.get(`${BASE}/options`)
        if (!res.success) throw new Error('Failed to fetch commissioning authority options')
        return res.data || { authorityTypes: [], nations: [] }
    },

    async create({ authorityName, authorityTypes, nations, legacyNames }) {
        const res = await api.post(BASE, { authorityName, authorityTypes, nations, legacyNames })
        if (!res.success) throw new Error('Failed to create commissioning authority')
        return res.data
    },

    async update(id, patch) {
        const res = await api.put(`${BASE}/${id}`, patch)
        if (!res.success) throw new Error('Failed to update commissioning authority')
        return res.data
    },

    async remove(id) {
        const res = await api.delete(`${BASE}/${id}`)
        if (!res.success) throw new Error('Failed to delete commissioning authority')
    },
}

export default commissioningAuthoritiesService
